import { render, staticRenderFns } from "./downloads1.vue?vue&type=template&id=890a2926&scoped=true&"
import script from "./downloads1.vue?vue&type=script&lang=js&"
export * from "./downloads1.vue?vue&type=script&lang=js&"
import style0 from "./downloads1.vue?vue&type=style&index=0&id=890a2926&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "890a2926",
  null
  
)

export default component.exports